var dataLayer = {
    pageInfo: {
        'pageName': "",
        'userID': "",
        'role': "",
        'module': ""
    }
};
//# sourceMappingURL=omniture.js.map